import { aboutInfo } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          {aboutInfo.title}
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            {aboutInfo.paragraphs.map((p, idx) => (
              <p
                key={idx}
                className="text-sm text-foreground-600 leading-relaxed mb-4 last:mb-0"
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}